import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {green50, greyishBlue50, greyishBlue600, orange50, red600} from "assets/jss/main";

import {formatDateTime} from "views/personalShopper/components/formatters";

MessageBubble.propTypes = {
    message: PropTypes.object.isRequired,
    shopperName: PropTypes.string,
};

const BACKGROUNDS = {
    shopper: greyishBlue50,
    agent: green50,
    human: orange50,
};

function MessageBubble({message, shopperName}) {
    const fromShopper = message.author === "shopper";
    const isCard = message.type === "product_card";
    const author = fromShopper
        ? (shopperName || <FormattedMessage id="personalShopper.author.shopper" />)
        : (message.author === "human" ? <>{message.by} <FormattedMessage id="personalShopper.author.team" /></> : <FormattedMessage id="personalShopper.author.agent" />);

    return (
        <div style={{display: "flex", justifyContent: fromShopper ? "flex-start" : "flex-end"}}>
            <div style={{
                maxWidth: "78%",
                padding: "8px 12px",
                borderRadius: "12px",
                backgroundColor: BACKGROUNDS[message.author] ?? greyishBlue50,
                fontSize: "14px",
            }}>
                <div style={{display: "flex", gap: "8px", alignItems: "baseline", marginBottom: "2px"}}>
                    <span style={{fontWeight: 600}}>{author}</span>
                    <span style={{color: greyishBlue600, fontSize: "11px"}}>{formatDateTime(message.createdAt)}</span>
                    {message.status === "failed" && (
                        <span style={{color: red600, fontSize: "11px", fontWeight: 600}}><FormattedMessage id="personalShopper.message.failed" /></span>
                    )}
                    {message.type !== "text" && !isCard && (
                        <span style={{color: greyishBlue600, fontSize: "11px"}}>{message.type}</span>
                    )}
                </div>
                {isCard && message.imageUrl && (
                    <img src={message.imageUrl} alt="" style={{width: "120px", borderRadius: "8px", display: "block", marginBottom: "6px"}} />
                )}
                <div style={{whiteSpace: "pre-wrap", wordBreak: "break-word"}}>{message.content}</div>
                {message.products && message.products.length > 0 && (
                    <div style={{marginTop: "6px", color: greyishBlue600, fontSize: "12px"}}>
                        <FormattedMessage id="personalShopper.message.cardsSent" />{" "}
                        {message.products.map((product) => `${product.brand ?? ""} ${product.name}`.trim()).join(", ")}
                    </div>
                )}
            </div>
        </div>
    );
}

export default MessageBubble;
